module.exports = __webpack_public_path__ + "static/img/wx-pay-guide.a8934b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/plane/wx-pay-guide.png
// module id = OR7E
// module chunks = 4